import React, { useState } from "react";
import { GraduationCap, Lock } from "lucide-react";
import LessonPlayer from "@/components/portal/lp/LessonPlayer";
import { PortalScreen } from "@/components/portal/lp/PortalScreen";

/** Locked pillar task: the homework lesson must be passed (4/5) before the question appears. */
export default function LessonGate({ a, pillar, token, onDone, onUnlocked }) {
  const [open, setOpen] = useState(false);
  const p = a.lesson || { answers: [], score: 0 };
  const answered = (p.answers || []).filter((x) => x !== null).length;
  const waiting = p.done && !p.passed;
  return (
    <article data-testid={`portal-lesson-${a.id}`} className="rounded-xl border border-[#d4a017]/40 bg-[#d4a017]/[0.06] p-5 space-y-3">
      <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#d4a017]"><Lock className="h-3.5 w-3.5" /> {pillar?.name || "Pillar"} · Week {a.program_week}</div>
      <p className="text-lg font-semibold">This week's question unlocks after your homework lesson.</p>
      <p className="text-sm text-white/60">{waiting ? `You scored ${p.score}/5. Your case manager will review it and may ask you to go through it again.`
        : answered ? `${answered} of 5 parts done — pick up where you left off.` : "5 short parts with a voice guide · about 15 minutes · get 4 of 5 right."}</p>
      {!waiting && (
        <button type="button" onClick={() => setOpen(true)} data-testid={`portal-lesson-start-${a.id}`} className="inline-flex items-center gap-2 rounded-md bg-[#d4a017] text-black font-semibold px-5 py-3">
          <GraduationCap className="h-5 w-5" /> {answered ? "Continue lesson" : "Start lesson"}
        </button>
      )}
      {open && (
        <PortalScreen title="Homework lesson" onBack={() => { setOpen(false); onDone(); }} testid="lesson-screen">
          <LessonPlayer token={token} assignmentId={a.id} onFinished={() => { setOpen(false); onDone(); onUnlocked?.(); }} />
        </PortalScreen>
      )}
    </article>
  );
}
